import * as palette from '@mlc/mlc-palette';
import React from 'react';
import { SearchDataItem } from '../../../../logic/domains/search.domain';
import { SearchElements } from '../SearchElements';
import SearchLinks from '../SearchLinks';
import * as Styled from './styled';

export interface Client {
	displayName: string;
	planId: string | null;
	partyFid: string | null;
}

interface DashboardSearchProps {
	onSearchSubmit: (searchQuery: string) => void;
	onSelectedFn: (
		clientNumber: string,
		profileToken: string,
		type: string
	) => void;
	data: Array<SearchDataItem> | null;
	recentClients: Array<SearchDataItem> | null;
}

interface State {
	value: string;
}

const initialState: State = {
	value: '',
};

class DashboardSearch extends React.Component<DashboardSearchProps, State> {
	private readonly elements = SearchElements;

	constructor(props: DashboardSearchProps) {
		super(props);
		this.state = initialState;
		this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
		this.onChanged = this.onChanged.bind(this);
		this.onSelected = this.onSelected.bind(this);
	}

	handleSearchSubmit() {
		this.props.onSearchSubmit(this.state.value);
	}

	onChanged = (searchQuery: string) => {
		this.setState({
			value: searchQuery,
		});
	};

	onSelected = (profileNumber: string, profileToken: string, type: string) => {
		this.props.onSelectedFn(profileNumber, profileToken, type);
	};

	public render() {
		return (
			<Styled.Card
				data-id={SearchElements.clientSearchContainer}
				data-analytics-group="dashboard-quick-search"
			>
				<Styled.ClientSearchHeader
					id={this.elements.clientSearchHeader}
					color={palette.mlcWhite}
					// Change Font Type
					variant="button"
				>
					Client search
				</Styled.ClientSearchHeader>
				<Styled.Wrapper>
					<Styled.QuickSearch
						data={this.props.data}
						onChangedFn={this.onChanged}
						onSelectedFn={this.onSelected}
						onSearchFn={this.handleSearchSubmit}
						recentClients={this.props.recentClients}
						analyticsId="dashboard-page-quick-search"
					/>
				</Styled.Wrapper>
				<SearchLinks />
			</Styled.Card>
		);
	}
}

export default DashboardSearch;
